import {
  Flex,
  Box,
  IconButton,
  useDisclosure,
  Stack,
  Collapse,
  Button,
  Text,
  Link as ChakraLink,
} from "@chakra-ui/react";
import React,{ useState,useEffect } from "react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { logout } from "../redux/reducers/authReducer";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Cookie from "js-cookie";
import toast from "react-hot-toast";
import axios from "axios";

const Navbar = () => {
  const { isOpen, onToggle } = useDisclosure();
  const token = Cookie.get("token");
  const customerId = localStorage.getItem("customerId");
  const [printData,setPrintData]=useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Logout Successfully");
    navigate("/");
    window.location.reload("/login");
  };
  const fetchData3=async()=>{
    const response= await axios.get(`https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`)
    setPrintData(response.data)
    console.log(response.data,'response.data')
    const rooms = response.data;
    const updatedRooms = await Promise.all(
      rooms.map(async (room) => {
        const imageResponse = await axios.get('https://api.rcb.tdrsoftware.in/image', {
          params: { customerId, key: room.image }
        });
        room.imageUrl = imageResponse.data;
        return room;
      })
    );
    console.log(updatedRooms, 'updatedRooms');
    setPrintData(updatedRooms);
}
console.log(printData,'printData')
useEffect(()=>{
  fetchData3()
},[customerId])

  const isActive = (path) => location.pathname === path;

  return (
    <Box>
      {/* Navbar */}
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        bg="tomato"
        color="white"
        padding={{ base: "0.5rem 1rem", md: "1rem 2rem" }}
        borderBottom="1px"
        borderColor="gray.200"
      >
        {/* Logo */}
        <Box fontSize="lg" fontWeight="bold" cursor="pointer">
        {
          printData.map((item) => (
          <Text onClick={() => navigate("/")}>{item.name}</Text>
           
          ))
        }
          <Text onClick={() => navigate("/")}></Text>
        </Box>

        {/* Hamburger Menu Icon for Mobile */}
        <Box display={{ base: "block", md: "none" }}>
          <IconButton
            onClick={onToggle}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            variant="ghost"
            aria-label="Toggle Navigation"
            color="white"
            _hover={{ bg: "gray.700" }}
          />
        </Box>

        {/* Desktop Menu */}
        <Box display={{ base: "none", md: "flex" }} alignItems="center">
          <Stack direction="row" spacing={4} align="center">
            {customerId ? (
              <>
                <ChakraLink
                  onClick={() => navigate("/dashboard")}
                  fontWeight="bold"
                  _hover={{ color: "gray.200" }}
                  borderBottom={isActive("/dashboard") ? "2px solid white" : ""}
                >
                  Dashboard
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/table-status")}
                  fontWeight="bold"
                  _hover={{ color: "gray.200" }}
                  borderBottom={isActive("/table-status") ? "2px solid white" : ""}
                >
                  Table Status
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/quickBill")}
                  fontWeight="bold"
                  _hover={{ color: "gray.200" }}
                  borderBottom={isActive("/quickBill") ? "2px solid white" : ""}
                >
                  Bill Report
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/dailyLedger")}
                  fontWeight="bold"
                  _hover={{ color: "gray.200" }}
                  borderBottom={isActive("/dailyLedger") ? "2px solid white" : ""}
                >
                  Daily Ledger
                </ChakraLink>
                <Button
                  size="sm"
                  onClick={handleLogout}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  size="sm"
                  onClick={() => navigate("/login")}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Login
                </Button>
                <Button
                  size="sm"
                  onClick={() => navigate("/signup")}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Signup
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Flex>

      {/* Mobile Menu Collapse */}
      <Collapse in={isOpen} animateOpacity>
        <Box
          display={{ base: isOpen ? "block" : "none", md: "none" }}
          bg="tomato"
          p={4}
        >
          <Stack spacing={4} align="center">
            {customerId ? (
              <>
                <ChakraLink
                  onClick={() => navigate("/dashboard")}
                  fontWeight="bold"
                  color="white"
                >
                  Dashboard
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/table-status")}
                  fontWeight="bold"
                  color="white"
                >
                  Table Status
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/quickBill")}
                  fontWeight="bold"
                  color="white"
                >
                  Bill Report
                </ChakraLink>
                <ChakraLink
                  onClick={() => navigate("/dailyLedger")}
                  fontWeight="bold"
                  color="white"
                >
                  Daily Ledger
                </ChakraLink>
                <Button
                  size="sm"
                  onClick={handleLogout}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  size="sm"
                  onClick={() => navigate("/login")}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Login
                </Button>
                <Button
                  size="sm"
                  onClick={() => navigate("/signup")}
                  bg="white"
                  color="tomato"
                  _hover={{ bg: "gray.100" }}
                >
                  Signup
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default Navbar;
